import { useState } from 'react';

import { gradient } from 'constants/theme';

import { Spinner } from 'components/shared/Spinner';

interface IProps {
  canFetchMore: boolean;
  fetchMore(): void;
}

export const FetchMoreButton = ({ canFetchMore, fetchMore }: IProps) => {
  const [isFetching, setIsFetching] = useState(false);

  if (!canFetchMore) {
    return null;
  }

  const handleClick = async () => {
    setIsFetching(true);

    try {
      await fetchMore();
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className="flex w-full justify-center pt-4">
      <button
        className="flex cursor-pointer items-center justify-center rounded-md bg-carnationRed py-2 px-3 text-sm text-white shadow-md disabled:cursor-default disabled:opacity-70 dark:text-mineShaftGrey"
        onClick={handleClick}
        disabled={isFetching}
        style={{ backgroundImage: gradient }}
      >
        {isFetching ? <Spinner size={16} /> : 'See more stories'}
      </button>
    </div>
  );
};
